import Vue from "vue";
import VueRouter from "vue-router";
import store from "@/store/index.js";
import { getToken } from '@/utils/auth';
Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "homenew",
    component: () => import(/*webpackChunkName: "Home" */ "@/views/HomeNew.vue"),
  },
  {
    path: "/login",
    name: "login",
    component() {
      return import("../views/Login.vue");
    },
  },
  {
    path: "/register",
    name: "register",
    component() {
      return import("../views/Register.vue");
    },
  },
  {
    path: "/inviteSuppliers",
    name: "inviteSuppliers",
    component() {
      return import("../views/InviteSuppliers.vue");
    },
  },
  {
    path: "/complain",
    name: "complain",
    component() {
      return import("../views/Complain.vue");
    },
  },
  {
    path: "/bind",
    name: "bind",
    component() {
      return import("../views/gzh/Bind.vue");
    },
  },
  {
    path: "/products",
    name: "products",

    component: () =>
      import(/* webpackChunkName: "Products" */ "../views/Products.vue"),
  },
  {
    path: "/jobs/:batchNumber",
    name: "jobs",

    component: () => import(/* webpackChunkName: "jobs" */ "../views/Jobs.vue"),
  },
  {
    path: "/enquiryNotices",
    name: "enquiryNotices",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/EnquiryNotices.vue"),
  },
  {
    path: "/enquiryNoticesView",
    name: "enquiryNoticesView",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/EnquiryNoticesView.vue"),
  },
  {
    path: "/inviteBid",
    name: "inviteBid",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/InviteBid.vue"),
  },
  {
    path: "/inviteBidView",
    name: "inviteBidView",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/InviteBidView.vue"),
  },
  {
    path: "/postscript",
    name: "postscript",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/Postscript.vue"),
  },
  {
    path: "/misconduct",
    name: "misconduct",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/Misconduct.vue"),
  },
  {
    path: "/bidAnnounce",
    name: "bidAnnounce",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/BidAnnounce.vue"),
  },
  {
    path: "/publicBid",
    name: "publicBid",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/PublicBid.vue"),
  },
  {
    path: "/publicBidView",
    name: "publicBidView",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/PublicBidView.vue"),
  },
  {
    path: "/news",
    name: "news",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/News.vue"),
  },
  {
    path: "/detail",
    name: "detail",
    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/Detail.vue"),
  },
  {
    path: "/materialType",
    name: "materialType",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/MaterialType.vue"),
  },
  {
    path: "/jobs/jobs/:id",
    name: "jobDetail",

    component: () =>
      import(/* webpackChunkName: "jobDetail" */ "../views/JobDetail.vue"),
  },
  {
    path: "/staff-stories/:id",
    name: "staff-story",

    component: () =>
      import(/* webpackChunkName: "staffStroy" */ "../views/StaffStory.vue"),
  },
  {
    path: "/userInfo",
    name: "Profile",
    component() {
      return import("../views/user/index.vue");
    },
  },
  {
    path: "/company",
    name: "company",
    /*meta: {
      loginRequired: true,
    },*/
    component: () =>
      import(/* webpackChunkName "resume"*/ "@/views/Company.vue"),
  },
  {
    path: "/company/edit",
    name: "companyEditor",
    /*meta: {
      loginRequired: true,
    },*/
    component: () =>
      import(/* webpackChunkName "resume-editor"*/ "@/views/CompanyEditor.vue"),
  },
  {
    path: "/homeNotices",
    name: "homeNotices",
    /*meta: {
      loginRequired: true,
    },*/
    component: () =>
      import(/* webpackChunkName "resume-editor"*/ "@/views/HomeNotices.vue"),
  },
  {
    path: "*",
    redirect: "/",
  },
  {
    path: "/delivery",
    name: "delivery",
    /*meta: {
      loginRequired: true,
    },*/
    component: () =>
      import(/* webpackChunkName "resume"*/ "@/views/Delivery.vue"),
  },
  {
    path: "/bidDelivery",
    name: "bidDelivery",
    /*meta: {
      loginRequired: true,
    },*/
    component: () =>
      import(/* webpackChunkName "resume"*/ "@/views/BidDelivery.vue"),
  },
  {
    path: "/changePassword",
    name: "changePassword",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/ChangePassword.vue"),
  },
  {
    path: "/enquiryListingDetail",
    name: "enquiryListingDetail",

    component: () => import(/* webpackChunkName: "PostNotices" */ "../views/EnquiryListingDetail.vue"),
  },
  {
    path: "/reportAdd",
    name: "reportAdd",
    component: () =>
      import("@/views/reportAdd.vue"),
  },
];

const router = new VueRouter({
  mode: "hash",
  // base:
  //   process.env.NODE_ENV !== "production"
  //     ? process.env.BASE_URL
  //     : process.env.BASE_URL  ,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // return { x: 0, y: 0 };
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
});

export default router;

router.onError((err) => {
  if (err.name === "ChunkLoadError") {
    router.app.$notify.error("网络资源加载错误");
  }
});


const whiteList = ['/', '/jobs', '/bind', '/login', '/register', '/inviteSuppliers', '/complain', '/news', '/changePassword', '/misconduct']
router.beforeEach((to, from, next) => {
  console.log(to.path, getToken());
  if (to.path === '/bind') {
    next()
  } else {
    /* 有token*/
    if (getToken()) {
      // 请求用户信息
      store.requestUserInfo().then(res =>{
        next();
      });
    } else {
      // 没有token
      if (whiteList.indexOf(to.path) !== -1 || to.path.indexOf("/jobs") !== -1) {
        // 在免登录白名单，直接进入
        next()
      } else {
        // 否则全部重定向到登录页
        // next('/login')

        // 页面全部放开不拦截
        next()
      }
    }
  }

});

// router.beforeEach((to, from, next) => {
//   console.log(to.path, state.isLogin);

//   if (to.path === "/login" && state.isLogin) {
//     return next("/");
//   }
//   if (to.meta.loginRequired && !state.isLogin) {
//     return next("/login");
//   }

//   next();
// });
